import stroe from '../vuex/index'
import Requests from '../axios/http'

// json格式转树状结构
const transData = function (a, idStr, pidStr, chindrenStr){    
    var r = [], hash = {}, id = idStr, pid = pidStr, children = chindrenStr, i = 0, j = 0, len = a.length;    
    for(; i < len; i++){    
        hash[a[i][id]] = a[i];    
    }
    for(; j < len; j++){    
        var aVal = a[j], hashVP = hash[aVal[pid]];    
        if(hashVP){    
            !hashVP[children] && (hashVP[children] = []);    
            hashVP[children].push(aVal);    
        }else{    
            r.push(aVal);    
        }    
    }    
    return r;    
}

// 全局数据
// const globalData = $.parseJSON(sessionStorage.getItem('Abp'))

// 接口地址
const url = {

}

// 版本信息
const versionInfo = [
    {
        version: '1.0.6',
        date: '2018-05-11',
        changeInfo: [
            {
                type: '添加',
                info: '教辅管理页面'
            }
        ]
    },{
        version: '1.0.5',
        date: '2018-05-08',
        changeInfo: [
            {
                type: '修复',
                info: '点击左侧菜单更多菜单不隐藏问题'
            },{
                type: '优化',
                info: '数据结构'
            },{
                type: '优化',
                info: '后台关系系统组织架构'
            },{
                type: '添加',
                info: '用户管理界面'
            }
        ]
    },{
        version: '1.0.4',
        date: '2017-10-25',
        changeInfo: [
            {
                type: '修复',
                info: '多用户登录菜单显示问题'
            },{
                type: '修复',
                info: '学校字段、鼠标码字段'
            },{
                type: '修复',
                info: '权限管理页面布局'
            }
        ]
    },{
        version: '1.0.3',
        date: '2017-10-20',
        changeInfo: [
            {
                type: '优化',
                info: '系统登录'
            },{
                type: '修复',
                info: '布局选中左侧菜单问题'
            }
        ]
    },{
        version: '1.0.2',
        date: '2017-06-15',
        changeInfo: [
            {
                type: '优化',
                info: '对页面布局进行调整，美化页面样式'
            },{
                type: '新增',
                info: '权限管理和权限分配两个页面'
            },{
                type: '增加',
                info: '修改密码页面'
            },{
                type: '添加',
                info: '学校页面新增组织机构代码主键'
            }
        ]
    },{
        version: '1.0.1',
        date: '2017-06-02',
        changeInfo: [
            {
                type: '优化',
                info: '左侧菜的单优化，对之前的bug进行修复。'
            },{
                type: '优化',
                info: '对页面中的按钮（颜色、位置、效果等）进行优化。'
            },{
                type: '优化',
                info: '右上角的个人信息，将对布局进行优化，信息更简练。'
            },{
                type: '增加',
                info: '将增加备课帮后台管理系统的升级记录页面。'
            },{
                type: '优化',
                info: '页面中的表单将增加验证功能，以防大家录错信息。'
            }
        ]
    },{
        version: '1.0.0',
        date: '2017-06-01',
        changeInfo: [
            {
                type: '发布',
                info: '备课帮后台管理系统发布'
            }
        ]
    }
]

// 本地存储信息
const Storage = {
    AuthorizationBearer:sessionStorage.getItem('AuthorizationBearer'),
    localStorage:localStorage,
    sessionStorage:sessionStorage,
}

export default {
    stroe,
    Requests,
    url,
    Storage,
    // globalData,
    transData,
    versionInfo
}


// WEBPACK FOOTER //
// ./src/Abp/Abp.js